<div class="flex items-center justify-center">
  <ng-container *ngIf="!formOpen">
    <button
      *isAllowed="[ERoleAdminString.Admin, 'device.create']"
      type="button"
      class="w-80 btn btn--secondary mr-5"
      (click)="formOpen = true"
    >
      Cadastrar Novo
    </button>
  </ng-container>

  <button
    *ngIf="formOpen"
    type="button"
    class="btn btn--secondary px-5 h-9 leading-4 text-center ml-auto"
    (click)="formOpen = false"
  >
    X
  </button>
</div>

<ng-container *ngIf="formOpen">
  <h1 class="text-lg font-bold leading-3">CADASTRAR NOVO DISPOSITIVO</h1>
  <small class="text-xs text-chathams-blue">Insira os dados abaixo para cadastrar</small>

  <form class="flex flex-col gap-5" [formGroup]="formDevice">
    <div class="w-full wrapper flex flex-col md:grid">
      <div class="form-group">
        <input type="text" class="form-input" placeholder="Nome" formControlName="name" />
      </div>

      <div class="form-group">
        <input type="text" class="form-input" placeholder="Identificador do Hardware" formControlName="hardwareId" />
      </div>

      <div class="form-group">
        <input
          type="text"
          class="form-input"
          placeholder="Identificador do Equipamento"
          formControlName="equipmentId"
        />
      </div>

      <div class="form-group">
        <input type="text" class="form-input" placeholder="Nome do Responsável" formControlName="contactName" />
      </div>

      <div class="form-group">
        <input
          type="text"
          class="form-input"
          placeholder="Contato do Responsável"
          formControlName="contactPhone"
          mask="(00) 0000-0000||(00) 0 0000-0000"
        />
      </div>

      <div class="form-group relative">
        <input type="text" class="form-input pr-20" placeholder="Licença do dispositivo" formControlName="licenseKey" />
        <div class="absolute right-0 top-1/2 flex items-center pr-2 -translate-y-1/2">
          <button
            type="button"
            title="Gerar Licença"
            (click)="generateLicense()"
            [class.hidden]="formDevice.get('licenseKey')?.value"
            [disabled]="formDevice.get('licenseKey')?.value"
          >
            <mat-icon>autorenew</mat-icon>
          </button>
          <button
            type="button"
            title="Copiar Licença"
            (click)="copyLicenseKey()"
            [class.hidden]="!formDevice.get('licenseKey')?.value"
            [disabled]="!formDevice.get('licenseKey')?.value"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </div>

      <div class="form-group">
        <input
          type="text"
          onfocus="(this.type='date')"
          onblur="(this.type='text')"
          class="form-input"
          placeholder="Data de Expiração (Opcional)"
          formControlName="expirationDate"
          [min]="minDate"
        />
      </div>

      <div class="form-group">
        <ng-select
          notFoundText="Nenhum item encontrado"
          [searchable]="false"
          placeholder="Tipo de dispositivo"
          formControlName="deviceTypeId"
        >
          <ng-option *ngFor="let deviceType of deviceTypes" [value]="deviceType.id">
            {{ deviceType.name }}
          </ng-option>
        </ng-select>
      </div>

      <div class="form-group" *ngIf="podeEscolherEmpresa">
        <ng-select
          notFoundText="Nenhum item encontrado"
          [searchable]="false"
          placeholder="Empresa"
          formControlName="companyId"
        >
          <ng-option *ngFor="let company of companies" [value]="company.id">
            {{ company.name }}
          </ng-option>
        </ng-select>
      </div>

      <div class="form-group" *ngIf="podeEscolherEmpresa">
        <ng-select
          notFoundText="Nenhum item encontrado"
          [searchable]="false"
          placeholder="Setup"
          formControlName="setupId"
          [disabled]="1 === 1"
        >
          <ng-option *ngFor="let setup of setupsOptions" [value]="setup.id">
            {{ setup.name }}
          </ng-option>
        </ng-select>
      </div>

      <div class="form-group">
        <input type="text" class="form-input" placeholder="Observação" formControlName="observation" />
      </div>
      <div class="form-group">
        <input
          type="text"
          class="form-input"
          placeholder="Identificador do Terminal de Pagamento"
          formControlName="paymentTerminalId"
        />
      </div>
    </div>

    <div class="form-group flex items-center justify-center">
      <button
        *isAllowed="[ERoleAdminString.Admin, 'device.create']"
        (click)="saveDevice()"
        class="w-80 h-9 btn btn--secondary"
      >
        + Salvar novo dispositivo
      </button>
    </div>
  </form>
</ng-container>
